export default __webpack_public_path__ + "classlink-logo.png";